import qs from "qs";
import axios from "axios";

function checkHTTPStatus(status) {
  if (status === 401) {
    localStorage.setItem("sessionExpired", true);
  }
}

export const get = async (url, body) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json"
    };
    const auth = localStorage.getItem("token");
    if (auth) {
      customHeaders.authorization = auth;
    }
    let res = null;
    if (body) {
      res = await fetch(`${url}?${qs.stringify(body)}`, {
        method: "get",
        headers: customHeaders
      });
    } else {
      res = await fetch(url, {
        method: "get",
        headers: customHeaders
      });
    }
    data = await res.json();
    checkHTTPStatus(res.status);
    // if (res.status >= 200 && res.status <= 200) {
    //   return data;
    // }
    // const error = new Error(res.errors);
    // error.response = res;
    // throw error;
    return data;
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

export const post = async (url, body, auth) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json"
    };
    const auth = localStorage.getItem("token");
    customHeaders.authorization = auth;

    const res = await fetch(url, {
      method: "POST",
      headers: customHeaders,
      body: JSON.stringify(body)
    });
    data = await res.json();
    checkHTTPStatus(res.status);
    if (data.status) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

export const postFile = async (url, body) => {
  let formData = body;
  try {
    const customHeaders = {
      "Content-Type": "multipart/form-data"
      // "Content-Type":
      //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };
    const auth = localStorage.getItem("token");
    customHeaders.authorization = auth;

    const data = await axios.post(url, formData, {
      headers: customHeaders
    });
    //  const res = await fetch(url, {
    //    method: "POST",
    //    headers: customHeaders,
    //    body: formData
    //  });

    checkHTTPStatus(data.status);
    if (data.status) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

export const put = async (url, body, formData = false) => {
  let data;
  const bodyValue = body;
  try {
    const customHeaders = {
      "Content-Type": "application/json"
    };
    const auth = localStorage.getItem("token");
    if (auth) {
      customHeaders.authorization = auth;
    }
    let res = null;
    if (formData) {
      res = await fetch(url, {
        method: "PUT",
        headers: { authorization: auth },
        Accept: "application/json",
        body: bodyValue
      });
    }
    if (!formData) {
      res = await fetch(url, {
        method: "PUT",
        headers: customHeaders,
        body: JSON.stringify(bodyValue)
      });
    }
    data = await res.json();
    checkHTTPStatus(res.status);
    if (data.status) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

export const getAltPay = async (url, body) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json",
      publicKey: process.env.REACT_APP_KEY_AUTH_PUBLIC_KEY,
      privateKey: process.env.REACT_APP_KEY_AUTH_PRIVATE_KEY
    };
    let res = null;
    if (body) {
      res = await fetch(`${url}?${qs.stringify(body)}`, {
        method: "get",
        headers: customHeaders
      });
    } else {
      res = await fetch(url, {
        method: "get",
        headers: customHeaders
      });
    }
    data = await res.json();
    checkHTTPStatus(res.status);
    // if (res.status >= 200 && res.status <= 200) {
    //   return data;
    // }
    // const error = new Error(res.errors);
    // error.response = res;
    // throw error;
    return data;
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

export const postAltPay = async (url, body, auth) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json"
    };
    customHeaders.token = body.header.token;

    const res = await fetch(url, {
      method: "POST",
      headers: customHeaders,
      body: JSON.stringify(body.body)
    });
    data = await res.json();
    checkHTTPStatus(res.status);
    if (data) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};
